export const AUTH_TOKEN = "auth_token";
export const PROJECTS_KEY = "projects";
export const API_ROOT = process.env.REACT_APP_API_ROOT;
// export const API_ROOT = "https://apidev-caltool.8p2-certification.com/api";
export const CURRENT_USER = "current_user";

export const STANDARD_VED_AR_N_4120 = "VDE-AR-N_4120"
export const STANDARD_VED_AR_N_4110 = "VDE-AR-N_4110"
